import {
  AfterContentInit,
  ContentChildren,
  Directive,
  ElementRef,
  NgZone,
  OnDestroy,
  QueryList,
} from "@angular/core";
import { NgSelectComponent } from "@ng-select/ng-select";

/**
 * Fecha qualquer `ng-select` aberto dentro do elemento anfitrião assim que
 * algo lá dentro faz scroll.
 *
 * Serve os `ng-select` com `appendTo` fora do contentor de scroll (por
 * exemplo, dentro de um `ngx-simplebar`): o painel de opções passa a ser
 * renderizado fora do contentor para não ser cortado, mas deixa de acompanhar
 * o campo quando o conteúdo faz scroll. Em vez de ficar a flutuar no sítio
 * errado, fecha-se; o utilizador volta a abri-lo com um clique.
 */
@Directive({
  selector: "[appCloseSelectsOnScroll]",
})
export class CloseSelectsOnScrollDirective implements AfterContentInit, OnDestroy {
  @ContentChildren(NgSelectComponent, { descendants: true })
  private selects!: QueryList<NgSelectComponent>;

  private readonly onScroll = (): void => {
    const open = this.selects?.filter((select) => select.isOpen) ?? [];
    if (!open.length) {
      return;
    }
    this.zone.run(() => open.forEach((select) => select.close()));
  };

  constructor(
    private readonly host: ElementRef<HTMLElement>,
    private readonly zone: NgZone
  ) {}

  ngAfterContentInit(): void {
    // O evento `scroll` não faz bubbling: em modo capture apanha-se o scroll
    // de qualquer descendente (o `.simplebar-content-wrapper`, tabelas, etc.).
    this.zone.runOutsideAngular(() =>
      this.host.nativeElement.addEventListener("scroll", this.onScroll, true)
    );
  }

  ngOnDestroy(): void {
    this.host.nativeElement.removeEventListener("scroll", this.onScroll, true);
  }
}
